module.exports = __webpack_public_path__ + "manhattan_nannies.png?7a2b185775a26c5ef96f63fb754d8c97";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/manhattan_nannies.png
// module id = 119
// module chunks = 0